import { render } from "./Layout05.vue?vue&type=template&id=fe84ac4a"
import script from "./Layout05.vue?vue&type=script&lang=js"
export * from "./Layout05.vue?vue&type=script&lang=js"

import "./Layout05.vue?vue&type=style&index=0&id=fe84ac4a&lang=sass"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer});
